module.exports = {
  b_path: `${process.env.VUE_APP_BACKEND_URL}/api/`,
  backendURL: `${process.env.VUE_APP_BACKEND_URL}`
  // // b_path: `${window.location.origin}/api/`
  // // b_path: 'https://dio.afrus.app/api/'
  // // b_path: 'http://localhost:3333/api/'
  // b_path: 'https://paulus.dar.agency/api/'
  // // b_path: 'https://my.afrus.app/api/'
}
